import { render, staticRenderFns } from "./IncidentEditHistory.vue?vue&type=template&id=c10e7f6a&"
import script from "./IncidentEditHistory.vue?vue&type=script&lang=js&"
export * from "./IncidentEditHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports